const getSubscriptionValue = (subscriptionOrStatus, key) => {
    if (subscriptionOrStatus && typeof subscriptionOrStatus === 'object') {
        return subscriptionOrStatus[key];
    }

    return key === 'status' ? subscriptionOrStatus : undefined;
};

const normalizeSubscriptionValue = (value) => (value || '').toString().trim().toLowerCase();

export const normalizeSubscriptionStatus = (subscriptionOrStatus) => {
    const rawStatus = normalizeSubscriptionValue(getSubscriptionValue(subscriptionOrStatus, 'status'));

    if (!rawStatus || rawStatus === 'free') {
        return 'Free';
    }

    if (['active', 'premium', 'vip/premium'].includes(rawStatus)) {
        return 'Premium';
    }

    if (rawStatus === 'venue') {
        return 'Venue';
    }

    if (rawStatus === 'pastdue' || rawStatus === 'past_due') {
        return 'PastDue';
    }

    if (rawStatus === 'cancelled' || rawStatus === 'canceled') {
        return 'Cancelled';
    }

    if (rawStatus === 'unpaid') {
        return 'Unpaid';
    }

    return getSubscriptionValue(subscriptionOrStatus, 'status');
};

export const getSubscriptionEntitlement = (subscriptionOrStatus) => {
    const rawEntitlement = normalizeSubscriptionValue(getSubscriptionValue(subscriptionOrStatus, 'entitlement'));

    if (!rawEntitlement) {
        return null;
    }

    if (rawEntitlement === 'premium') {
        return 'Premium';
    }

    if (rawEntitlement === 'venue') {
        return 'Venue';
    }

    if (rawEntitlement === 'free') {
        return 'Free';
    }

    return getSubscriptionValue(subscriptionOrStatus, 'entitlement');
};

export const isPremiumStatus = (subscriptionOrStatus) => normalizeSubscriptionStatus(subscriptionOrStatus) === 'Premium';

export const isVenueStatus = (subscriptionOrStatus) => normalizeSubscriptionStatus(subscriptionOrStatus) === 'Venue';

export const isFreeStatus = (subscriptionOrStatus) => normalizeSubscriptionStatus(subscriptionOrStatus) === 'Free';

export const hasActivePremiumEntitlement = (subscriptionOrStatus) => {
    const entitlement = getSubscriptionEntitlement(subscriptionOrStatus);
    const isActive = getSubscriptionValue(subscriptionOrStatus, 'isActive');

    if (entitlement === 'Premium') {
        return typeof isActive === 'boolean' ? isActive : true;
    }

    if (typeof isActive === 'boolean') {
        return isActive && isPremiumStatus(subscriptionOrStatus);
    }

    return isPremiumStatus(subscriptionOrStatus);
};

export const getAccessTier = (subscriptionOrStatus) => {
    if (isVenueStatus(subscriptionOrStatus) || getSubscriptionEntitlement(subscriptionOrStatus) === 'Venue') {
        return 'Venue';
    }

    if (hasActivePremiumEntitlement(subscriptionOrStatus)) {
        return 'Premium';
    }

    return 'Free';
};

export const hasPaidPlan = (subscriptionOrStatus) => getAccessTier(subscriptionOrStatus) !== 'Free';

export const getSubscriptionLabel = (subscriptionOrStatus) => normalizeSubscriptionStatus(subscriptionOrStatus);
